import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { Editor, Toolbar, ToolbarDropdown } from 'ngx-editor';
import { containsEmojis, removeEmojis } from "@k2/common/k2-forms/utils";

@Component({
    selector: 'markdown-editor',
    templateUrl: 'markdown-editor.component.html',
    styleUrls: ['markdown-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MarkdownEditorComponent implements OnInit, OnChanges, OnDestroy {
  @Input() id?: string;
  @Input() value: string;
  @Input() disabled = false;
  @Input() placeholder?: string;
  @Input() noPreview?: boolean = false;
  @Input() showMenu: boolean = true;
  @Output() valueChange = new EventEmitter();
  @Output() touch = new EventEmitter();

  @ViewChild('preview') preview: ElementRef;

  editable = false;
  minHeight = null;

  html = '';
  editor: Editor;
  headingDropdown: ToolbarDropdown = {
    heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6']
  }
  toolbar: Toolbar = [['bold', 'italic'], ['underline', 'strike'], ['ordered_list', 'bullet_list'],
    ['text_color', 'background_color'], [this.headingDropdown],  ['align_left', 'align_center', 'align_right', 'align_justify']];

  ngOnInit(): void {
    this.editor = new Editor();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.value) {
      if (!containsEmojis(changes.value.currentValue)) {
        this.html = this.value;
      } else {
        this.html = removeEmojis(changes.value.previousValue);
        if (this.editor) {
          this.editor.setContent(this.html);
        }
      }
    }
  }

  showInput() {
    if (this.preview) {
      const matDialogContentElement = document.getElementsByTagName('mat-dialog-content')[0];
      if (matDialogContentElement instanceof HTMLElement) {
        this.minHeight = matDialogContentElement.offsetHeight * 0.8 + 'px';
      }
    }

    this.editable = true;
  }

  showPreview() {
    this.editable = false;
  }

  @HostListener('paste', ['$event'])
  pasteFromClipboard(event: KeyboardEvent): void {
    event.preventDefault();

    if (this.insertClipboardImage(event)) {
      return;
    }
  }

  private insertClipboardImage(event): File | null {
    const pastedImage = this.getPastedImage(event);

    if (!pastedImage)
      return null;

    return pastedImage;
  }

  private getPastedImage(event): File | null {
    if (event.clipboardData) {
      if (event.clipboardData.files && event.clipboardData.files.length && this.isImageFile(event.clipboardData.files[0])) {
        return event.clipboardData.files[0];
      }
    }

    return null;
  }

  private isImageFile(file: File): boolean {
    return file.type.search(/^image\//i) === 0;
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }
}
